import React, { useId } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { BROWSE_SORTS, type BrowseSort } from 'fym-shared/src/music24/browseSearch';
import { TypedMemo } from '../../../common/types';
import { browseMessages as messages } from '../browseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseSearch.module.scss';
/* eslint-enable css-modules/no-unused-class */

export const BROWSE_SORT_LABELS = {
  match: messages.sortMatch,
  reach: messages.sortReach,
  playlists: messages.sortPlaylists,
  change7d: messages.sortChange,
  followers: messages.sortFollowers,
} as const;

interface BrowseSortSelectProps {
  value: BrowseSort;
  onChange: (sort: BrowseSort) => void;
}

/** Sort (design a2): Best match, Playlist reach, Most playlists, 7-day change, Followers. */
const BrowseSortSelectComponent: React.FC<BrowseSortSelectProps> = ({ value, onChange }) => {
  const intl = useIntl();
  const selectId = useId();
  return (
    <label htmlFor={selectId} className={clsx(styles.dropdown, value !== 'match' && styles.dropdownSet)}>
      <span>{intl.formatMessage(messages.sortLabel)}</span>
      <select
        id={selectId}
        className={styles.select}
        value={value}
        onChange={(event) => onChange(event.target.value as BrowseSort)}
        data-testid="browse-sort"
      >
        {BROWSE_SORTS.map((sort) => (
          <option key={sort} value={sort}>
            {intl.formatMessage(BROWSE_SORT_LABELS[sort])}
          </option>
        ))}
      </select>
    </label>
  );
};

export const BrowseSortSelect = TypedMemo(BrowseSortSelectComponent);
